export function pad(num: number, size: number, padChar = "0"): string {
  let s = num + "";
  while (s.length < size) {
    s = padChar + s;
  }
  return s;
}
